/**
 * Spanish labels for the AI settings vocabulary. UI-only display config
 * (`uiConfig.ts` rules): never backend-sourced, so it is imported directly.
 */

import type { AiEffort, SettingsAiProvider, SlackReplyTone } from '@zunelo/shared';

export const AI_PROVIDER_LABELS: Record<SettingsAiProvider, string> = {
  'opencode-go': 'OpenCode Go',
  gemini: 'Gemini',
  'openai-codex': 'OpenAI / Codex',
};

export const EFFORT_LABELS: Record<AiEffort, string> = {
  low: 'bajo',
  medium: 'medio',
  high: 'alto',
};

export const TONE_LABELS: Record<SlackReplyTone, string> = {
  professional: 'Profesional',
  casual: 'Casual',
  direct: 'Directo',
  warm: 'Cálido',
};
